import React from "react";
import { motion } from "framer-motion";
import Box from "@mui/material/Box";

import ContactsV2 from "./ContactsV2";
import ModelsContainer from "../ModelsContainer";
import HMUContainer from "../HMUContainer";

const PeopleTab = ({ jobData, clientData, setHasUnsavedChanges }) => {

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{
        type: "spring",
        stiffness: 300,
        damping: 30,
        mass: 1,
      }}
    >
      <Box
        sx={{
          p: 1,
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <ContactsV2 client={clientData} />

        <ModelsContainer
          jobData={jobData}
          setHasUnsavedChanges={setHasUnsavedChanges}
        />

        <HMUContainer
          jobData={jobData}
          setHasUnsavedChanges={setHasUnsavedChanges}
        />
      </Box>
    </motion.div>
  );
};

export default PeopleTab;